const BitcoinCnt = {
  symbol: "BTC",
  name: "bitcoin",
  meta: {
    title: "Buy bitcoins, sell bitcoins, prices and Bitcoin charts",
    description:
      "Experience safe and fast bitcoin trading (BTC) here. Coin Nick Market has made it possible to buy and sell bitcoins without intermediaries and with low fees.",
    keywords: "Bitcoin, buy bitcoins, sell bitcoins, bitcoin prices",
  },
  scripts: {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    mainEntity: [
      {
        "@type": "Question",
        name: "چگونه بیت کوین بخرم؟",
        acceptedAnswer: {
          "@type": "Answer",
          text: " در پلتفرم معاملاتی کوین‌نیک مارکت می‌توانید با کارت بانکی عضو شتاب و کمترین کارمزد، بدن واسطه اقدام به خرید بیت کوین کنید.",
        },
      },
      {
        "@type": "Question",
        name: "بهترین کیف پول بیت کوین کدام است؟",
        acceptedAnswer: {
          "@type": "Answer",
          text: " انواع مختلفی از کیف پول‌های بیت کوین وجود دارد. کیف پول‌های نرم افزاری قابل نصب روی کامپیوتر و موبایل، کیف پول‌های سخت افزاری و کیف پول‌های مبتنی بر سایت‌های آنلاین. هرکدام از آن‌ها از نظر امنیت، راحتی استفاده و رعیات حریم خصوصی متفاوت هستند و کاربران باید آن‌ها را بررسی کنند. در لیست زیر بهترین کیف پول‌های بیت کوین را معرفی کرده‌ایم: کیف پول نرم‌افزاری  Trust Walletبرای موبایل؛ کیف پول سخت‌افزاری Ledger؛ کیف پول سخت‌افزاری Trezor؛ کیف پول تحت وب متامسک Metamask؛ کیف پول نرم‌افزاری Exodus برای دسکتاپ و موبایل؛ کیف پول نرم‌افزاری Bitcoin Wallet برای موبایل؛ کیف پول تحت وب Blockchain.com و کیف پول‌ صرافی کوین نیک مارکت.",
        },
      },
      {
        "@type": "Question",
        name: " آیا در کوین نیک مارکت می‌توانم بیت کوین نگهداری کنم؟",
        acceptedAnswer: {
          "@type": "Answer",
          text: "در کوین‌نیک مارکت یک کیف پول اختصاصی و امن دارید، که می‌توانید رمزارزهیاتان را در آن نگهداری کنید. در این صورت دیگر هیچ نگرانی و استرسی بابت مسدود شدن موجودی‌تان در صرافی‌های خارجی به علت تحریم‌های مالی علیه ایران نخواهید داشت.",
        },
      },
      {
        "@type": "Question",
        name: "آیا بیت کوین ارزش سرمایه‌گذاری دارد؟",
        acceptedAnswer: {
          "@type": "Answer",
          text: "قیمت بیت کوین در سال ۲۰۰۹ کمتر از یک دلار بود، سال ۲۰۲۱ اما به بالای ۶۰ هزار دلار رسید. به عبارتی اگر شما ده سال پیش ۱۰۰ دلار بیت کوین خریده بودید، حالا سرمایه شما بیش از ۱۰ میلیون دلار شده بود. از طرفی در حال حاضر بیش از ۳۰۰ فروشگاه و ارائه‌دهنده خدمات در سرتاسر جهان از پرداخت بیت کوین پشتیبانی می‌کنند و شرکت‌هایی بزرگی مانند تسلا و پی پال سرمایه‌گذاری میلیارد دلاری روی بیت کوین انجام داده‌اند. همه این عوامل نشان‌دهنده آن است که بی‌شک آینده بیت کوین روشن‌تر از هر زمان دیگری است.",
        },
      },
    ],
  },
  faq: [
    {
      question: "How to buy bitcoin?",
      answer:
        "In Quinnik Market trading platform, you can buy bitcoins with the bank card of Shetab member and the lowest fee, the intermediary body.",
      id: "toggler1",
    },
    {
      question: "What is the best bitcoin wallet?",
      answer: "Faq_bitcoin_wallet",
      id: "toggler2",
    },
    {
      question: "Can I keep bitcoins in Coin Nick Market?",
      answer: "Keep_bitcoin_description",
      id: "toggler3",
    },
    {
      question: "Is Bitcoin worth the investment?",
      answer: "Bitcoin_investment",
      id: "toggler4",
    },
  ],
  body: [
    [
      {
        heroTitle: "General information about Bitcoin",
        subTitle: "What is Bitcoin?",
        content: "Bitcoin_description",
        btnTitle: "",
        btnLink: "",
        linkTitle: "",
        Link: "",
      },
      {
        heroTitle: "",
        subTitle: "Bitcoin story",
        content: "Bitcoin_history_description",
        btnTitle: "Buy and sell bitcoins",
        btnLink: "",
        linkTitle: "Read more on the blog",
        Link: "",
      },
    ],
    [
      {
        heroTitle:
          "Bitcoin buying and selling without intermediaries in coinnik Market",
        subTitle: "Buy Bitcoin",
        content: "Buy_bitcoin_description",
        btnTitle: "",
        btnLink: "",
        linkTitle: "",
        Link: "",
      },
      {
        heroTitle: "",
        subTitle: "Sale Bitcoin",
        content: "sale_bitcoin_description",
        btnTitle: "Buy and sell bitcoins",
        btnLink: "",
        linkTitle: "",
        Link: "",
      },
    ],
  ],

  blogTitle: "The latest bitcoin analysis on the blog",
  informationTitle: "Bitcoin market statistics and information",
};

export default BitcoinCnt;
